module.exports = __webpack_public_path__ + "static/media/gemini.b653068e.svg";